import React from "react";
import { ListItem, ListItemData } from "./list-item";
import * as styles from "./list.module.scss";

export type { ListItemData };

export interface ListProps {
  items: ListItemData[];
  size?: "small";
}

export const List: React.FC<ListProps> = ({ items, size }) => (
  <ul className={`${styles.list}${size === "small" ? ` ${styles.small}` : ""}`}>
    {items.map((item, i) => (
      <ListItem key={i} data={item} size={size} />
    ))}
  </ul>
);
